/**
 * D6LifeExtraFieldType - Type d'extraField pour les PV D6
 * Identique à PlayerLifeExtraField.java
 */

import {ExtraFieldType} from '../../types/ExtraFieldType';
import {GameDataExtraField} from '../../../models/GameDataExtraField';
import {GameState} from '../../../models/GameState';
import {getValueDice} from '../util/DiceUtil';

export class D6LifeExtraFieldType implements ExtraFieldType {
  typeName = 'D6_PV';
  defaultValue = '1D+6';

  process(field: GameDataExtraField, gameState: GameState): void {
    // Pas de traitement spécial nécessaire
  }

  /**
   * Génère une valeur à partir d'une expression D6
   * Utilise DiceUtil.getValueDice() comme en Java
   * 
   * @param fieldValue Expression D6 (ex: "1D+6", "1D+12", "1")
   * @returns Valeur générée (ex: "7", "13", "1")
   */
  generateValue(fieldValue: string): string {
    return getValueDice(fieldValue).toString();
  }
}
